import { TeamSummaryPage } from "../../modules/team-summary"

interface TeamSummaryProps {
  sidebarOpen?: boolean
}

export default function TeamSummary({ sidebarOpen }: TeamSummaryProps) {
  return <TeamSummaryPage />
}
